export default __webpack_public_path__ + "static/media/10.ce9e63f5.webp";